import { render, staticRenderFns } from "./KomisariatList.vue?vue&type=template&id=78816bce"
import script from "./KomisariatList.vue?vue&type=script&lang=js"
export * from "./KomisariatList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports